import Test from './test';

export default (di) => {
	di
		.setType({type: Test, name: 'Test', parent: 'PageComponent'})
	;
};
